<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
export default {
  name: "Test",
  data() {
    return {};
  },
  methods: {
    start() {},
  },
  components: {
    Footer,
  },
};
</script>

<style lang="less" scoped>
</style>